import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ArrowLeft, MailCheck } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import api, { formatApiError } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6" data-testid="forgot-password-page">
      <div className="w-full max-w-md">
        <Link to="/login" className="inline-flex items-center gap-1.5 text-sm text-slate-500 mb-8" data-testid="forgot-back-link"><ArrowLeft className="h-4 w-4" /> Back to login</Link>
        {sent ? (
          <div className="rounded-2xl bg-white border border-slate-200 p-8 text-center" data-testid="forgot-sent">
            <div className="h-14 w-14 rounded-2xl bg-green-100 flex items-center justify-center mx-auto mb-5"><MailCheck className="h-7 w-7 text-green-600" /></div>
            <h1 className="text-2xl font-extrabold text-[#0F2744]">Check your email</h1>
            <p className="mt-3 text-slate-500">If an account exists for <strong>{email}</strong>, we've sent a link to reset your password. It expires in one hour.</p>
            <Button asChild className="mt-6 bg-[#0F2744] hover:bg-[#0B192C]"><Link to="/login" data-testid="forgot-return-login">Return to login</Link></Button>
          </div>
        ) : (
          <>
            <h1 className="text-3xl font-extrabold text-[#0F2744]">Forgot your password?</h1>
            <p className="mt-2 text-slate-500">Enter your email and we'll send you a link to reset it.</p>
            <form onSubmit={submit} className="mt-8 space-y-5" data-testid="forgot-form">
              <div>
                <Label className="mb-1.5 block">Email</Label>
                <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email" />
              </div>
              {error && <p className="text-sm text-red-600" data-testid="forgot-error">{error}</p>}
              <Button type="submit" disabled={loading} className="w-full bg-[#0F2744] hover:bg-[#0B192C] h-12" data-testid="forgot-submit">
                {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Send reset link"}
              </Button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
